
export enum middleType {
    none = 'none',
    C = 'C',
}